/**
 * Return whether the "includesSubQuestions" flag has been sent in via the props.
 */

import type { RootState } from '/business/shared/state/store';
import type { Step1SelectorProps } from '/business/shared/state/selectors/types';

export default (_state: RootState, ownProps: Step1SelectorProps | null = null): boolean =>
  ownProps?.includesSubQuestions || false;
